export const BEAT_TYPES = {
  NARRATIVE: 'narrative',
  INPUT: 'input',
  DECISION: 'decision',
  CHARACTER_RESPONSE: 'character_response',
  NARRATIVE_RESPONSE: 'narrative_response',
  RESOLUTION: 'resolution',
}

export const PLAYER_STATUS = {
  IDLE: 'idle',
  PLAYING: 'playing',
  COMPLETE: 'complete',
}
